import React from 'react';
import PropTypes from 'prop-types';
import AdvInput, { advInputTextChanged } from '../../../CommonComponents/AdvInput';
import AdvForm from '../../../CommonComponents/AdvForm';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';
import { isNumeric, createCustomPropType, isUuid } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';

const { ADV } = window;

const View = ({
  clientId,
  title,
  groupTitle,
  areOptionsLoaded,
  goalId,
  whatIfType,
  storeData,
  hasSpouse,
  principalName,
  spouseName,
  principalYearlyCost,
  spouseYearlyCost,
}) => (
  <div className="what-ifs-layout-content">
    <h4 className="what-if-group-title">{groupTitle}</h4>
    <AdvForm>
      <ValidationErrors clientId={clientId} />
      <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
        <li className="what-ifs-form-field">
          <h5 className="what-if-title">{title}</h5>
        </li>
        <li className="what-ifs-form-field">
          <label
            className="what-ifs-insurance-label"
            htmlFor="PrincipalYearlyCost"
          >
            <span className="what-ifs-label-text">{principalName}</span>
            <br />
            <AdvInputWrapper hasCurrency hasPerYear className="what-ifs-input-wrapper">
              <AdvInput
                autoComplete="off"
                id="PrincipalYearlyCost"
                type="text"
                dataType="money"
                maxLength="14"
                onBlur={advInputTextChanged(
                  clientId,
                  storeData(goalId, whatIfType),
                  'WhatIf.PrincipalYearlyCost',
                )}
                value={ADV.util.formatValue(principalYearlyCost, 'money')}
                className="what-ifs-input"
              />
            </AdvInputWrapper>
          </label>
        </li>
        {hasSpouse && (
          <li className="what-ifs-form-field">
            <label
              className="what-ifs-insurance-label"
              htmlFor="SpouseYearlyCost"
            >
              <span className="what-ifs-label-text">{spouseName}</span>
              <br />
              <AdvInputWrapper hasCurrency hasPerYear className="what-ifs-input-wrapper">
                <AdvInput
                  autoComplete="off"
                  id="SpouseYearlyCost"
                  type="text"
                  dataType="money"
                  maxLength="14"
                  onBlur={advInputTextChanged(
                    clientId,
                    storeData(goalId, whatIfType),
                    'WhatIf.SpouseYearlyCost',
                  )}
                  value={ADV.util.formatValue(spouseYearlyCost, 'money')}
                  className="what-ifs-input"
                />
              </AdvInputWrapper>
            </label>
          </li>
        )}
      </ul>
    </AdvForm>
  </div>
);
View.defaultProps = {
  title: '',
  groupTitle: '',
  spouseName: '',
  spouseYearlyCost: 0,
};

View.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  whatIfType: PropTypes.number.isRequired,
  storeData: PropTypes.func.isRequired,
  hasSpouse: PropTypes.bool.isRequired,
  principalName: PropTypes.string.isRequired,
  spouseName: PropTypes.string,
  spouseYearlyCost: PropTypes.number,
  principalYearlyCost: PropTypes.number.isRequired,
};

export default View;
